import React from "react";
import MarketoFormComponent from './marketoFormComponent';
import '../../sass/components/_components.marketo.scss';

const MarketoForm = ({ externalLink, indItem, wistiaVideoId, ctaOverride, formID, formSubmitMessage, formSubmitThankYouPage, formSubmitPdf, ctabgcolor }) => {
    return (
        <MarketoFormComponent externalLink={externalLink} indItem={indItem} wistiaVideoId={wistiaVideoId} ctaOverride={ctaOverride} formId={formID} formSubmitMessage={formSubmitMessage} formSubmitThankYouPage={formSubmitThankYouPage} formSubmitPdf={formSubmitPdf} ctabgcolor={ctabgcolor} />
    );
}

export default MarketoForm;